import React, { useState } from "react";
import { FcGoogle } from "react-icons/fc";
import { FaApple, FaMicrosoft } from "react-icons/fa";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import {API_URL} from "../../constants"


const Login = () => {
  const { type } = useParams();
  const navigate = useNavigate();
  const title = type === "candidate" ? "Candidate Login" : "Recruiter Login";
  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const response = await axios.post(API_URL + "authy/login", {
        email: formData.email,
        password: formData.password,
      });

      if (response.data.message === "Authentication successful") {
        // Store token and user data
        localStorage.setItem("token", response.data.token);
        localStorage.setItem(
          "userData",
          JSON.stringify({
            username: response.data.username,
            profilePicture: response.data.profile_picture,
            status: response.data.status,
            account_type: response.data.account_type,
            organisation: response.data.organisation
          })
        );

        // Redirect based on account type
        const accountType = response.data.account_type;
        console.log(accountType)
        switch (accountType) {
          case "client":
            navigate("/recruitment_manager/dashboard");
            break;
          case "candidate":
            navigate("/candidate/dashboard");
            break;
                    case "linka":
            navigate("/jobs");
            break;
          default:
            navigate("/dashboard");
            break;
        }
      }
    } catch (err) {
      setError(err.response?.data?.error || "Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
        <h2 className="text-2xl text-black font-semibold text-center mb-6">
          {title}
        </h2>

        {error && (
          <div className="mb-4 p-2 bg-red-100 text-red-700 rounded-md">
            {error}
          </div>
        )}

        <form className="space-y-4" onSubmit={handleSubmit}>
          {/* Email Input */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Email *
            </label>
            <input
              type="email"
              name="email"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleInputChange}
              className="w-full text-black mt-1 p-2 border border-gray-300 rounded-md focus:ring focus:ring-green-300 placeholder:text-gray-400"
              required
            />
          </div>

          {/* Password Input */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Password *
            </label>
            <input
              type="password"
              name="password"
              placeholder="Enter your password"
              value={formData.password}
              onChange={handleInputChange}
              className="w-full text-black mt-1 p-2 border border-gray-300 rounded-md focus:ring focus:ring-green-300 placeholder:text-gray-400"
              required
            />
          </div>

          {/* Forgot Password */}
          <div className="text-right text-sm text-green-600 cursor-pointer">
            <Link to={`/auth/forgot-password/${type}`}>Forgot Password</Link>
          </div>

          {/* Login Button */}
          <button 
            type="submit" 
            disabled={loading}
            className="w-full bg-teal-600 text-white py-2 mt-4 rounded-md hover:bg-teal-700 transition disabled:bg-gray-400"
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        {/* OR Separator */}
        <div className="flex items-center my-4">
          <hr className="flex-grow border-gray-300" />
          <span className="px-2 text-gray-500 text-sm">OR</span>
          <hr className="flex-grow border-gray-300" />
        </div>

        {/* Social Logins */}
        <a href="http://127.0.0.1:8000/accounts/google/login/" className="w-full bg-black text-white py-2 rounded-md flex items-center justify-center gap-2 mb-2">
          <FcGoogle className="w-5 h-5" />
          Login with Google
        </a>

        {/* Sign Up Link */}
        <p className="text-center text-sm text-gray-600 mt-4">
          Don't have an account?{" "}
          <span className="text-green-600 cursor-pointer">
            <Link to={`/auth/signup/${type}`}>Create account</Link>
          </span>
        </p>
      </div>
    </div>
  );
};

export default Login;